<template>
    <div class="card card-body text-center">
        <div class="form-group mt-3 flex justify-center text-center">
            <img class="task-img" src="/images/animat-shopping-cart-color.gif">
        </div>
        <h4 class="text-lg font-medium">Invoice & Payment Pending</h4>
        <p class="leading-loose my-6">
            We will be sending your annual invoice to: <span class="block font-bold text-indigo-600">{{ invoiceRecipients }} </span>
        </p>
        <div class=" form-inline mt-2" v-if="sendInvoiceEmail">
            <div class="text-center m-auto form-group">
                <div class="mr-1">
                    <input class="form-control" type="text"
                           v-model="form.email"
                           placeholder="Enter email address"
                           :class="{'is-invalid': form.errors.has('email')}">
                    <span class="invalid-feedback w-auto"
                          v-show="form.errors.has('email')">
                        {{ form.errors.get("email") }}
                    </span>
                </div>
                <button class="btn btn-success waves-effect waves-light mr-1 align-self-baseline"
                        @click.prevent="resendInvoice()"
                        :disabled="form.busy">
                    {{form.busy ? "Sending..." : "Send"}}
                </button>
                <button class="btn btn-default waves-effect waves-light mr-1 align-self-baseline"
                        @click.prevent="sendInvoiceEmail = false"
                        :disabled="form.busy">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: ["invoiceRecipients"],

        data () {
            return {
                sendInvoiceEmail: false,
                form: new AppForm({
                    email: this.invoiceRecipients
                })
            };
        },

        methods: {

            resendInvoice () {

                App.post("/onboarding/invoice/send", this.form)
                .then(() => {
                    this.sendInvoiceEmail = false;
                    swal(
                        "Email sent!",
                        "Registration invoice sent to " + this.form.email + "!",
                        "success"
                    );
                });

            }
        }

    };
</script>
